export const ExperimentsConfig = {
    Variants: {
        A: 'varianta',
        B: 'variantb',
        C: 'variantc',
        fallback: 'varianta',
    },
};
